var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSwiperSlide } from 'swiper/react';
import BackgroundImageSrc from '../../../assets/images/Home/Carousel/Background.svg';
import BackgroundImageFillSrc from '../../../assets/images/Home/Carousel/BackgroundFill.svg';
var initialState = true;
var CardCarouselItem = function (_a) {
    var title = _a.title, content = _a.content, cta = _a.cta, ctaLink = _a.ctaLink, index = _a.index, setActiveMobile = _a.setActiveMobile, activeMobile = _a.activeMobile;
    var swiperSlide = useSwiperSlide();
    var isItemActiveMobile = useMemo(function () {
        return activeMobile === index && !swiperSlide;
    }, [activeMobile]);
    var isActive = swiperSlide ? swiperSlide.isActive : isItemActiveMobile;
    var stateBasedColorClasses = useMemo(function () {
        var baseColorClassObject = {
            link: "text-white",
            title: "text-white",
            separator: "border-white",
        };
        if (isActive) {
            baseColorClassObject.link = "text-enblue";
            baseColorClassObject.title = "text-enblue-900";
            baseColorClassObject.separator = "border-engray";
        }
        return baseColorClassObject;
    }, [isActive]);
    var handleCardClick = function () {
        if (!swiperSlide) {
            initialState = false;
            if (isItemActiveMobile) {
                setActiveMobile(null);
            }
            else {
                setActiveMobile(index);
            }
        }
    };
    if (!swiperSlide && initialState && index == 0) {
        setActiveMobile(index);
    }
    return (_jsxs("div", __assign({ className: "card-item swiper-slide relative  mx-auto my-2.5 w-full border bg-cover bg-clip-padding bg-no-repeat px-0  transition-all duration-500 ease-in-out md:my-0 md:block md:border-0 md:border-transparent md:pt-14 lg:mx-2 lg:px-12 lg:pt-12 " + (isActive
            ? 'card-item--active border-transparent text-enblue-900'
            : ' border-white text-white') + " " + (isItemActiveMobile
            ? 'card-item--active-mobile pt-10'
            : 'flex items-center'), onClick: handleCardClick, tabIndex: 0, style: {
            backgroundImage: (!swiperSlide && isItemActiveMobile) || swiperSlide
                ? "url(" + (isActive ? BackgroundImageFillSrc : BackgroundImageSrc) + ")"
                : "",
        } }, { children: [_jsx("span", __assign({ className: "card-item__card-header relative z-50  w-full  justify-center  border-engray md:inline-block md:px-7 lg:border-b lg:px-7 " + stateBasedColorClasses.separator }, { children: _jsxs("h5", __assign({ className: "card-header__title  my-auto text-center font-normal  md:block md:pb-5 lg:pb-6 " + stateBasedColorClasses.title + " relative " + (isItemActiveMobile ? 'px-16 pb-6' : '') }, { children: [title, _jsx("span", { className: "absolute  left-0 right-0 bottom-0 tab-width  mx-auto w-10/12 bg-engray md:block md:w-44 lg:hidden " + (isItemActiveMobile ? 'block' : 'hidden') + " bottom-line", style: {
                                height: ".07rem",
                                // width: `12.31rem`,
                            } }, void 0)] }), void 0) }), void 0),
            _jsx("span", __assign({ className: "card-item__card-body mx-auto mt-5 px-10 md:mx-0 md:mt-4 md:flex md:h-36 md:px-12 lg:px-1 lg:pt-2 lg:center " + (isItemActiveMobile ? 'flex px-7' : 'hidden') }, { children: _jsx("p", __assign({ className: "card-body__paragraph  mx-auto text-center  font-light" }, { children: content }), void 0) }), void 0),
            _jsxs("span", __assign({ className: "card-item__card-footer margin-bottom absolute left-0 right-0 mx-auto items-center justify-center space-x-2 pt-7 text-sm font-semibold lg:bottom-10 lg:pt-8 xl:bottom-12 " + (isItemActiveMobile ? 'flex' : 'hidden md:flex') }, { children: [_jsx("a", __assign({ href: ctaLink, role: "button", className: "card-footer__link  block " + stateBasedColorClasses.link }, { children: cta }), void 0),
                    _jsxs("svg", __assign({ className: "w-4 stroke-current " + stateBasedColorClasses.link, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M1 6.09433H13.35", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }, void 0),
                            _jsx("path", { d: "M10.1523 1.74829L14.4497 6.00009L10.1523 10.2519", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }, void 0)] }), void 0)] }), void 0),
            _jsx("span", { className: "absolute  left-0 right-0 bottom-0  mx-auto w-full bg-engray md:inline-block md:w-0 " + (isItemActiveMobile ? 'block' : 'hidden'), style: {
                    height: ".07rem",
                } }, void 0)] }), void 0));
};
export default CardCarouselItem;
